export const extraCareServiceName = 'JB Hi-Fi Extra Care';

export enum ServiceIds {
  AppleCareNz = 'apple-care-nz', //Apple Care NZ
  MobileExtras = 'mobile-extras', //JB Hi-Fi Extras AU
  ExtraCare = 'extended-care', //JB Hi-Fi Extra Care AU
  ExtraCareNz = 'extended-care-nz', //JB Hi-Fi Extra Care NZ
  Install = 'install', // JB Hi-Fi Install
}

export const nonInstallServiceIds: Array<ServiceIds> = [
  ServiceIds.MobileExtras,
  ServiceIds.ExtraCare,
  ServiceIds.ExtraCareNz,
  ServiceIds.AppleCareNz,
];

export const EXTRACARE_REPLACEMENT_COVER_SKU = '7800500';

export const OLD_APPLIANCE_REMOVAL_SKU = '350099';
export const CABLE_HIDING_SKU = '350080';
export const INSTALL_TERMS_PATH = '/pages/help-and-support/jb-hi-fi-installation-terms-and-conditions';
export const INSTALL_INCLUSIONS_AND_EXCLUSIONS_PATH = '/pages/tv-mounting';
